import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { ApiService } from './global.service';
import { ConfigService } from './config.service';
import { LocalStorageService } from './storage.service';

export interface TrialSignupPayload {
  fullName: string;
  email: string;
  whatsapp: string;
  businessName: string;
}

export interface ProvisionResponse {
  keycloakUrl: string;
  realm: string;
  clientId: string;
  tenantId?: string;
}

@Injectable({ providedIn: 'root' })
export class TenantProvisioningService extends ApiService {
  constructor(
    public override http: HttpClient,
    public override config: ConfigService,
    public override localStorageService: LocalStorageService,
    handler: HttpBackend
  ) {
    super(http, config, localStorageService, handler);
  }

  provisionTrialTenant(payload: TrialSignupPayload): Observable<ProvisionResponse> {
    const url = `${this.URL}/tenant/provision-trial`;
    return this.postNoAuth<ProvisionResponse>(url, payload);
  }
}
